<template>
  <div class="tw-inline-block">
    <IconButton
      color="outline-secondary"
      @click="openModal(EDIT_PROFESSION_TITLE_MODAL_NAME)"
      test_id="profession-title-edit"
    >
      <PenIcon />
    </IconButton>

    <FormModal
      :name="EDIT_PROFESSION_TITLE_MODAL_NAME"
      header="Edit Profession Title"
    >
      <FormModalBody
        footer-button-text="Save"
        :is-button-loading="form.processing"
        @submit="saveForm"
      >
        <div>
          <FormInput
            v-model="form.profession_title"
            :is-error="Boolean(form.errors.profession_title)"
            :errors="form.errors.profession_title"
            @input="form.clearErrors('profession_title')"
            type="text"
            test_id="profession-title-input"
          >
            <template #label>Profession title</template>
          </FormInput>
        </div>
      </FormModalBody>
    </FormModal>
  </div>
</template>

<script setup>
import IconButton from '@/shared/components/IconButton.vue'
import FormModal from '@/shared/components/modals/FormModal/FormModal.vue'
import FormModalBody from '@/shared/components/modals/FormModal/FormModalBody.vue'
import FormInput from '@/shared/components/forms/FormInput.vue'
import PenIcon from '@/assets/images/icons/pen.svg'
import { useForm } from '@inertiajs/vue3'
import { EDIT_PROFESSION_TITLE_MODAL_NAME } from '@/shared/data/globalVariables.js'
import { useModals } from '@/shared/composables/useModals.js'

const props = defineProps({
  professionTitle: {
    type: String,
    default: '',
  },
})

const { closeModal, openModal } = useModals()

const form = useForm({
  profession_title: props.professionTitle,
})

const saveForm = () => {
  form
    .transform((data) => ({
      mentor: data,
    }))
    .patch('/profile/mentor/profession_titles', {
      preserveScroll: true,
      onSuccess: () => {
        closeModal(EDIT_PROFESSION_TITLE_MODAL_NAME)
      },
    })
}
</script>
